
import { Input } from "@/components/ui/input";
import { useIsMobile } from "@/hooks/use-mobile";
interface AddressInputFieldsProps {
  street: string;
  street2: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
export const AddressInputFields = ({
  street,
  street2,
  onChange
}: AddressInputFieldsProps) => {
  const isMobile = useIsMobile();
  return <div className="space-y-3">
      <div>
        <input type="text" placeholder="Unit number, Complex/Estate name, etc." name="street2" value={street2} onChange={onChange} className="form-input w-full" />
      </div>
      <div>
        <input type="text" value={street} name="street" onChange={onChange} placeholder="Street address will appear here after search" className="form-input w-full" />
      </div>
    </div>;
};
